<template>
  <LanguageSwitcher :options="options" />
</template>

<script>
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher.vue";

export default {
  name: "app",
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      options: JSON.parse(this.$options._parentVnode.data.props.options),
    };
  }
};
</script>
